module.exports = __webpack_public_path__ + "img/503a4c8160f4b60804d56b4793f756f5.dc76335d.png";